import {IdName} from '@domain/id-name';
import {AssertionUtils} from '@vdw/angular-component-library';
import {DateTime} from 'luxon';

export class SchedulePattern {
  private _id: number | string;
  private _pattern: IdName;
  private _startDate: DateTime;
  private _endDate: DateTime;

  public constructor(id: number | string, pattern: IdName, startDate: DateTime, endDate: DateTime) {
    this._id = id;
    this._pattern = pattern;
    this._startDate = startDate;
    this._endDate = endDate;
  }

  public get id(): number | string {
    return this._id;
  }

  public get pattern(): IdName {
    return this._pattern;
  }

  public get startDate(): DateTime {
    return this._startDate;
  }

  public get endDate(): DateTime {
    return this._endDate;
  }

  public static fromJSON(schedulePatternJSON: any): SchedulePattern {
    return new SchedulePattern(
      schedulePatternJSON.id,
      IdName.fromJSON(schedulePatternJSON.pattern),
      DateTime.fromISO(schedulePatternJSON.startTime, {zone: 'utc'}).setZone(DateTime.local().zoneName, {keepLocalTime: true}),
      AssertionUtils.isNullOrUndefined(schedulePatternJSON.endTime) ? null : DateTime.fromISO(schedulePatternJSON.endTime, {zone: 'utc'}).setZone(DateTime.local().zoneName, {keepLocalTime: true})
    );
  }

  public toJSON(): JSON {
    return {
      id: typeof this._id === 'number' ? this._id : undefined,
      patternId: this._pattern.id,
      startTime: this._startDate.setZone('utc', {keepLocalTime: true}).toISO(),
      endTime: this._endDate?.setZone('utc', {keepLocalTime: true})?.toISO()
    } as any as JSON;
  }
}
